<template>
	<v-container fluid style="height:100%">
		<v-row>
			<v-col cols="12" sm="2" md="2">
				<et-list
				:items="roleArray"
				:title="listTitle"
				ref="roleList"
				@return-current="returnCurrent">
			        <template v-slot:header>
			          	<v-btn color="success" @click="addRole()">{{$vuetify.lang.t('$vuetify.custom.addBtn')}}<!-- 添加 --></v-btn>
			        </template>
			        <template v-slot:li-right-second="{item}">
			        	<v-btn x-small color="primary" @click="updateRole(item.id)">{{$vuetify.lang.t('$vuetify.custom.dict.editBtn')}}<!-- 修改 --></v-btn>
			        </template>
			        <template v-slot:li-right-first="{item}">
			        	<v-btn x-small color="error" @click="deleteRole(item.id)">{{$vuetify.lang.t('$vuetify.custom.deleteBtn')}}<!-- 删除 --></v-btn>
			        </template>
		      	</et-list>
	      	</v-col>
	      	<!-- <v-col cols="12" sm="1" md="1"></v-col> -->
	      	<v-col cols="12" sm="2" md="2">
	      		<div class="title">{{$vuetify.lang.t('$vuetify.custom.operation.addOperation') + $vuetify.lang.t('$vuetify.custom.jurisdiction')}}</div>
	      		<element-tree
	      		:data="items"
		    	:expanded="operationExpanded"
		    	@return-all="returnAllOperation"
                :checkStrictly="true"
		    	ref="operationTree">
	      		</element-tree>
	      	</v-col>
	      	<v-col cols="12" sm="1" md="1"></v-col>
	      	<v-col cols="12" sm="2" md="2">
	      		<div class="title">{{$vuetify.lang.t('$vuetify.custom.data') + $vuetify.lang.t('$vuetify.custom.jurisdiction')}}</div>
	      		<element-tree
	      		:data="orgItems"
		    	:expanded="orgExpanded"
		    	@return-all="returnAllOrg"
                :checkStrictly="true"
		    	ref="orgTree">
	      		</element-tree>
	      	</v-col>
      	</v-row>
      	<v-row>
			<v-col cols="12" sm="7" md="7">
		    	<div class="my-2" style="text-align:center;" @click="saveJurisdiction">
		        	<v-btn large color="primary">{{$vuetify.lang.t('$vuetify.custom.preservation')}}</v-btn>
		      	</div>
	      	</v-col>
      	</v-row>
      	<v-dialog v-model="dialog" persistent max-width="500px">
        	<role-info v-model="dialog" @initialize="initializeFun" :title="dialogtitle" :addOrUpdate="addOrUpdate" :roleId="roleId"></role-info>
      	</v-dialog>
	</v-container>
</template>
<script>
 	import EtList from '@/components/list/ETList'
 	import ElementTree from '@/components/tree/ElementTree'
 	import roleInfo from './role-info'
	export default{
		data(){
			return{
				items: [],//操作权限数据
		        roleArray:[],//角色列表数据
		        listTitle:this.$vuetify.lang.t('$vuetify.custom.role.role'),
		        orgExpanded:[],//组织树默认展开
		        operationExpanded:[],//操作树默认展开
		        orgItems:[],//组织树数据
		        selectedRoleId:'',//当前选中角色
		        operationChecked:[],//被选中操作
		        orgChecked:[],//被选中组织
		        dialog:false,
		        dialogtitle:'',
		        addOrUpdate:true,
                operationDeal:false,//操作权限修改标识
                orgDeal:false,//数据权限修改表示
		        roleId:'',//传输角色id


			}
		},
		methods:{
			addRole(){
				this.dialog = true;
				this.dialogtitle = this.$vuetify.lang.t('$vuetify.custom.addBtn') + this.$vuetify.lang.t('$vuetify.custom.role.role');//'添加角色'

				this.addOrUpdate = true;
			},
			updateRole(id){
				this.dialogtitle = this.$vuetify.lang.t('$vuetify.custom.dict.editBtn') + this.$vuetify.lang.t('$vuetify.custom.role.role');//'修改角色';
				this.addOrUpdate = false;
				this.roleId = id;
				this.dialog = true;
			},
			deleteRole(id){
				this.$api.sysRole.deleteRole(id).then(data =>{
					if(data.flag){
						this.$dialog.alert(this.$vuetify.lang.t('$vuetify.custom.deleteBtn') + this.$vuetify.lang.t('$vuetify.custom.success'));
						this.listRole();
					}else{
						this.$dialog.alert(data.msg)
					}
				})
			},
			//弹窗回调
			initializeFun(){
				this.listRole();
			},
			//根据角色id查询操作权限
			queryOperationPermission(id){
				this.$api.sysRolePermission.rolePermission(id).then(data =>{
					if(data.flag){
						let array = [];
						array = [...data.data];
						this.$refs.operationTree.setCheckedKeys(array);
					}
				})
			},
			//根据角色id查询数据权限
			quertyDataPermission(id){
				this.$api.sysDataPermission.dataPermission(id).then(data =>{
					if(data.flag){
						let array = [];
						array = [...data.data];
						// console.info('quertyDataPermission',array);
						this.$refs.orgTree.setCheckedKeys(array);
					}
				})
			},
			//加载组织树
			loadOrganization(){
		        this.$api.sysOrganization.selectOrganization().then(data => {
		        	if(data.flag){
		        		this.orgItems = data.data;
		        		// for(let i = 0;i < data.data.length;i++){
                        //     this.orgChecked.push(data.data[i].id);
                        // }
                        // this.orgChecked = data.data;
		        		let array = [];
						array.push(data.data[0].id);
						this.orgExpanded = array;
		        	}


		        })
		     },
		     //保存权限
			saveJurisdiction(){
				if(!this.operationDeal && !this.orgDeal){
                    this.$dialog.alert("请操作后再保存");
				}else{
                    let obj = {
                        roleId:this.selectedRoleId,
                        operationIds:this.operationChecked,
                        orgId:this.orgChecked,
                        operationDeal:this.operationDeal,
                        orgDeal:this.orgDeal
                    }
                    this.$api.sysRole.saveRolePermission(obj).then(data =>{
                        if(data.flag){
                            this.$dialog.alert(this.$vuetify.lang.t('$vuetify.custom.preservation') + this.$vuetify.lang.t('$vuetify.custom.success'));
                        }else{
                            this.$dialog.alert(data.msg)
                        }
                    })
                }
				// console.info('saveJurisdiction',this.$refs.operationTree.getCheckedKeys());
				// console.info('getCurrentKey',this.$refs.roleList.getCurrentKey());
			},
			//查询角色
			async listRole(){
				await this.$api.sysUserRole.listRole().then(data =>{
					if(data.flag){

						this.roleArray = [...data.data];
						this.$refs.roleList.setCurrentKey(this.roleArray[0].id);
						this.queryOperationPermission(this.roleArray[0].id);
						this.quertyDataPermission(this.roleArray[0].id);
					}
				})


			},
			//操作树
			treePermission(){
				this.$api.sysPermission.treePermission().then(data =>{
					if(data.flag){
						this.items = data.data;
                        // for(let i = 0;i < data.data.length;i++){
                        //     this.operationChecked.push(data.data[i].id);
                        // }
						// this.operationChecked = data.data;
						let array = [];
						array.push(data.data[0].id);
						this.operationExpanded = array;
					}
				})
			},
			returnCurrent(val){
                this.operationDeal = false;
                this.orgDeal = true;

				this.queryOperationPermission(val);
				this.quertyDataPermission(val);
				this.selectedRoleId = val;
			},
			returnAllOperation(val){
				this.operationChecked = val;
				this.operationDeal = true;
				console.info('returnAllOperation',val);
			},
			returnAllOrg(val){
				this.orgChecked = val;
				this.orgDeal = true;
				console.info('returnAllOrg',val);
			}
		},
		created(){
			this.treePermission();
			this.listRole();
			this.loadOrganization();
		},
		components:{
			EtList,
			ElementTree,
			roleInfo
		}
	}
</script>
<style scoped>
/*标题样式*/
	.title{
		background:rgb(21, 101, 192);
		text-align:center;
		color:white;
		border-radius:20px;
	}
</style>
